import './BotAvatar.css'

export function BotAvatar(){
    return <div>
        <div className="bot-avatar">
            
        </div>
    </div>
}